import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getAccountState } from "../../redux/slices/accountSlice";
import {
  isSubscriptionPaymentFailed,
  userPhoneVerificationStatus,
} from "@markit/common.utils";
import { TwilioPhoneVerificationStatus, ThemeType } from "@markit/common.types";
import VerificationAccountStatusItem from "./VerificationAccountStatusItem";
import NoticeBanner from "./NoticeBanner";

interface NoticeBannersWrapperProps {
  onVerificationStatusPress: () => void;
  eventTheme?: ThemeType;
}

const NoticeBannersWrapper = ({
  onVerificationStatusPress,
  eventTheme,
}: NoticeBannersWrapperProps) => {
  const { account } = useSelector(getAccountState);
  const { accountData } = account;

  const paymentFailedSubscription = useMemo(
    () => isSubscriptionPaymentFailed(accountData.customer.state),
    [accountData.customer.state]
  );

  const shouldShowVerificationBanner = useMemo(
    () =>
      userPhoneVerificationStatus(accountData) !==
        TwilioPhoneVerificationStatus.UNVERIFIED &&
      !accountData.customer.phoneVerification.showedAccountApproval, // if user is not unverified status, then phoneVerification object will not be undefined

    [accountData]
  );

  return paymentFailedSubscription || shouldShowVerificationBanner ? (
    <div className="ColumnNormal" style={{ gap: 7 }}>
      {paymentFailedSubscription ? (
        <NoticeBanner eventTheme={eventTheme} />
      ) : null}
      {shouldShowVerificationBanner ? (
        <VerificationAccountStatusItem
          onPress={onVerificationStatusPress}
          eventTheme={eventTheme}
        />
      ) : null}
    </div>
  ) : null;
};

export default NoticeBannersWrapper;
